<div class="jumbotron centered-text">
    Byly založeny případy: <span class="comma-list"><span *ngFor="let createdCase of data.createdCases">
      <a uiSref="symap.project.cases.detail" [uiParams]="{id: createdCase.id}">{{'pro LV '+(createdCase.titles[0]|titleName)+' '}}{{createdCase.mpp.number||'Bez čísla'}}</a></span></span>.
</div>

<div class="mt-10">
    <gmt-button [clickAction]="submit">Přejít na stavební objekt</gmt-button>
    <gmt-button [clickAction]="goToCasesBulkOperation">Provést hromadnou akci se založenými případy</gmt-button>
</div>
